<template>
  <transition name="el-zoom-in-top" @after-leave="doDestroy">
    <div
      v-show="showPopper"
      class="el-autocomplete-suggestion el-popper waypoint-autocomplete-suggestion"
      :class="{ 'is-loading': !parent.hideLoading && parent.loading }"
      :style="{ width: dropdownWidth }"
      role="region">
      <el-scrollbar
        tag="ul"
        wrap-class="el-autocomplete-suggestion__wrap"
        view-class="el-autocomplete-suggestion__list">
        <li v-if="!parent.hideLoading && parent.loading" class="loading-container">
          <svg-icon name="icon-16-loading" class="loading-icon" />
          Loading
        </li>
        <slot v-else>
        </slot>
      </el-scrollbar>
    </div>
  </transition>
</template>
<script>
  import Popper from 'element-ui/src/utils/vue-popper';
  import Emitter from 'element-ui/src/mixins/emitter';

  export default {
    mixins: [Popper, Emitter],

    componentName: 'ElAutocompleteSuggestions',

    data() {
      return {
        parent: this.$parent,
        dropdownWidth: ''
      };
    },

    props: {
      options: {
        default() {
          return {
            gpuAcceleration: false
          };
        }
      },
      id: String
    },

    methods: {
      select(item) {
        this.dispatch('ElAutocomplete', 'item-click', item);
      }
    },

    updated() {
      this.$nextTick(() => {
        this.popperJS && this.updatePopper();
      });
    },

    mounted() {
      this.$parent.popperElm = this.popperElm = this.$el;
      this.referenceElm = this.$parent.$refs.input.$refs.input || this.$parent.$refs.input.$refs.textarea;
      this.referenceList = this.$el.querySelector('.el-autocomplete-suggestion__list');
      this.referenceList.setAttribute('role', 'listbox');
      this.referenceList.setAttribute('id', this.id);
    },

    created() {
      this.$on('visible', (val, inputWidth) => {
        this.dropdownWidth = inputWidth + 'px';
        this.showPopper = val;
      });
    }
  };
</script>
<style lang="scss" scoped>
.waypoint-autocomplete-suggestion {
  border: 1px solid #E7EBF3;
  box-shadow: 0px 1px 5px rgba(0, 5, 57, 0.2);
  border-radius: 4px;
  padding: 8px !important;
  max-height: 300px;
  overflow-y: overlay;
  margin-top: 4px !important;
  margin-bottom: 4px !important;
  z-index: 2222 !important;
  ::v-deep {
    ul, li {
      padding: 0 !important;
    }
    .highlighted {
      border-radius: 4px !important;
    }
    .el-autocomplete-suggestion__wrap {
      padding: 0 !important;
    }
  }
  &.is-loading .loading-container {
    text-align: left !important;
    height: 36px !important;
    display: flex;
    align-items: center;
    font-family: OpenSans;
    font-style: normal;
    font-weight: 600;
    font-size: 12px !important;
    line-height: 16px !important;
    color: #000000 !important;
    .loading-icon {
      margin-right: 8px;
      font-size: 20px;
      animation: rotating 1s linear infinite;
    }
  }
}
</style>